import { render, staticRenderFns } from "./Settings.htm?vue&type=template&id=3e2703d4&scoped=true&"
import script from "./Settings.js?vue&type=script&lang=js&"
export * from "./Settings.js?vue&type=script&lang=js&"
import style0 from "./Settings.scss?vue&type=style&index=0&id=3e2703d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2703d4",
  null
  
)

export default component.exports